import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
  LOCALE_ID,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  HttpClientModule,
  HTTP_INTERCEPTORS,
  HttpClient,
} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HomeComponent } from './pages/home/home.component';
import { AppHttpInterceptor } from './interceptors/http.interceptor';
import { CommonModule } from '@angular/common';
import { APP_BASE_HREF } from '@angular/common';
// ng zorro module
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzCarouselModule } from 'ng-zorro-antd/carousel';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzBackTopModule } from 'ng-zorro-antd/back-top';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NgxMaskModule, IConfig } from 'ngx-mask';


import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { DictionaryComponent } from './config/dictionary/dictionary.component';
import { NzFormModule } from 'ng-zorro-antd/form';
import { LogComponent } from './log/log.component';
import { GenerateComponent } from './config/generate/generate.component';

// 翻译插件
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { GlobalConfigComponent } from './config/global-config/global-config.component';
import { CustomConfigComponent } from './config/custom-config/custom-config.component';
import { NoAuthComponent } from './pages/errors/no-auth/no-auth.component';
import { AppFooterComponent } from './pages/layout/app-footer/app-footer.component';
import { AppHeaderComponent } from './pages/layout/app-header/app-header.component';
import { OfficialWebsiteHeaderComponent } from './pages/official-website/official-website-header/official-website-header.component';
import { IndexComponent } from './pages/home/index/index.component';
import { HomePageComponent } from './pages/official-website/home-page/home-page.component';
import { HomePageBackupComponent } from './pages/official-website/home-page-backup/home-page-backup.component';
import { PercentRingComponent } from './pages/official-website/home-page-backup/percent-ring/percent-ring.component';
import { ServicesComponent } from './pages/official-website/services/services.component';
import { PartsComponent } from './pages/official-website/ecat/parts.component';
import { VinSearchComponent } from './pages/official-website/ecat/vin-search/vin-search.component';
import { VinPartsSearchComponent } from './pages/official-website/ecat/vin-parts-search/vin-parts-search.component';
import { ServiceTrainingComponent } from './pages/official-website/services/service-training/service-training.component';
import { EquipmentServicesComponent } from './pages/official-website/services/equipment-services/equipment-services.component';
import { EmptyNewPageComponent } from './pages/official-website/empty-new-page/empty-new-page.component';
import { NewsCenterComponent } from './pages/official-website/news-center/news-center.component';
import { NewsDetailComponent } from './pages/official-website/news-center/news-detail/news-detail.component';
import { DieselRepairNetworkComponent } from './pages/official-website/services/diesel-repair-network/diesel-repair-network.component';
import { BSSPartsSelectionComponent } from './pages/official-website/services/bss-parts-selection/bss-parts-selection.component';
import { CVPlanComponent } from './pages/official-website/services/cv-plan/cv-plan.component';
import { VideoModalComponent } from './pages/official-website/ecat/video/video-modal.component';
import { VideoPlayerComponent } from './pages/official-website/ecat/video/video-player.component';
import { SafeUrlPipe } from './pages/official-website/ecat/video/safe-url.pipe';
import { ExtraRewardsComponent } from './pages/official-website/services/extra-rewards/extra-rewards.component';
import { ScrollSpyNavComponent } from './pages/official-website/scroll-navigation/scroll-spy-nav.component';
import { ContactUsComponent } from './pages/official-website/home-page/contact-us/contact-us.component';
import { OfficialWebsiteFooterComponent } from './pages/official-website/official-website-footer/official-website-footer.component';
import { QuickAddComponent } from './pages/quick-add/quick-add.component';
import { SubTitleComponent } from './pages/layout/sub-title/sub-title.component';
import { BreadcrumbNavigation } from './pages/layout/breadcrumb-nav/breadcrumb-nav.component';
import { MultipleLineComponent } from './pages/quick-add/multiple-line/multiple-line.component';
import { CsvExcelComponent } from './pages/quick-add/csv-excel/csv-excel.component';
import { CartComponent } from './pages/cart/cart.component';
import { CartListComponent } from './pages/cart/cart-list/cart-list.component';
import { CartTableComponent } from './pages/cart/cart-table/cart-table.component';


// 订单的相关组件
import { OrderSuccessComponent } from './pages/order-success/order-success.component';
import { OrderHistoryIndex } from './pages/order/index.component';
import { DeliveryHistoryComponent } from './pages/order/deliveryHistory/delivery.component';
import { FinancialDataComponent } from './pages/order/financial-data/financial-data.component';
import { DatePipe } from '@angular/common';
import { OrderHistoryComponent } from './pages/order/order-history/order-history.component';
import { ItemHistoryComponent } from './pages/order/item-history/item-history.component';
import { CartAddressComponent } from './pages/cart/cart-address/cart-address.component';
import { ProgressComponent } from './pages/order/progress/progress.component';
import { LogProcessComponent } from './pages/order/item-history/log-process/log-process.component';
import { SvgIconComponent } from './pages/layout/svg-icon/svg-icon.component';
import { EditAddressComponent } from './pages/cart/edit-address/edit-address.component';
import { UserInfoComponent } from './pages/user-info/user-info.component';
import { MyAccountComponent } from './pages/user-info/my-account/my-account.component';
import { DataPrivacyMessage } from './pages/user-info/data-privacy/data-privacy.component';
import { UserTermsMessage } from './pages/user-info/user-terms/user-terms.component';
import { MyAccountSoldToDetail } from './pages/user-info/sold-to-detail/sold-to-detail.component';
import { CustomTagComponent } from './pages/layout/custom-tag/custom-tag.component';
import { ChooseAddressComponent } from './pages/cart/choose-address/choose-address.component';
import { NotificationComponent } from './pages/home/notification/notification.component';
import { NotificationDataComponent } from './pages/home/notification-data/notification-data.component';
import { InvoiceDataComponent } from './pages/order/invoice-data/invoice-data.component';
import { NotificationSettingComponent } from './pages/notification-setting/notification-setting.component';
import { OrganizationProfileComponent } from './pages/user-info/organization-profile/organization-profile.component';
import { OrderDetailComponent } from './pages/order/order-detail/order-detail.component';
import { LoadingComponent } from './pages/layout/loading/loading.component';
import { LoadingInterceptor } from './interceptors/loading-interceptor';
import { LoadingService } from './services/loading.service';
import { ProductComponent } from './pages/product/product.component';
import { SearchComponent } from './pages/product/search/search.component';
import { ProductVinSearchComponent } from './pages/product/mobile/vin-search/index.component';
import { ProductCompanySearchComponent } from './pages/product/mobile/company-search/index.component';
import { NewFeatureGuideComponent } from './pages/layout/new-feature-guide/new-feature-guide.component';
import { PromotionPopupWindowComponent } from './pages/layout/promotion-popup-window/promotion-popup-window.component';


import { CategoryComponent } from './pages/product/category/category.component';
import { ProductCategoryMobileComponent } from './pages/product/mobile/category/index.component';
import { ProductDetailComponent } from './pages/product/product-detail/product-detail.component';
import { ProductDetailMobileComponent } from './pages/product/mobile/product-detail/index.component';
import { ProductListMobileComponent } from './pages/product/mobile/product-list/index.component';
import { ProductVehicleSearchComponent } from './pages/product/mobile/vehicle-search/index.component';

import { VehicleModalComponent } from './pages/product/vehicle-modal/vehicle-modal.component';
import { OrderInProcessComponent } from './pages/cart/order-in-process/order-in-process.component';
import { OrderFailedComponent } from './pages/cart/order-failed/order-failed.component';
import { WishlistComponent } from './pages/cart/wishlist/wishlist.component';
import { CartIndexComponent } from './pages/cart/index/index.component';
import { TargetAchievementComponent } from './pages/target-achievement/target-achievement.component';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { UserManagementModule } from './setting/user-management/user-management.module';
import { RoleManagementModule } from './setting/role-management/role-management.module';
import { PermissionManagementModule } from './setting/permission-management/permission-management.module';
import { MagnifyDirective } from './directive/magnify.directive';
import { DebounceClickDirective } from './directive/debounce-click.directive';
// dealer portal
import { DealerPortalHome } from './pages/dealerPortal/home/home.component';
import { DealerTargetAchievementComponent } from './pages/dealerPortal/home/TargetAchievement/index.component';
import { DealerWorkshopAcquisitionComponent } from './pages/dealerPortal/home/WorkshopAcquisition/index.component';
import { DealerPortalRightSectionComponent } from './pages/dealerPortal/home/PortalRightSection/index.component';

import { CopyPasteComponent } from './pages/quick-add/copy-paste/copy-paste.component';
// sales portal
import { SalesPortalNavComponent } from './pages/layout/sales-portal-nav/sales-portal-nav.component';
import { SpCircleProgressComponent } from './pages/sales-portal/circle-progress/circle-progress.component';
import { ProductGroupTableComponent } from './pages/sales-portal/product-group-table/product-group-table.component';
import { TwoColumnTableComponent } from './pages/sales-portal/two-column-table/two-column-table';
import { SalesPortalHeaderComponent } from './pages/sales-portal/sales-portal-header/sales-portal-header.component';
import { SalesPortalInputNumberComponent } from './pages/sales-portal/sales-portal-input-number/sales-portal-input-number.component';
import { InputNumberModule } from 'primeng/inputnumber';
// sales portal - turnover
import { TurnoverComponent } from './pages/sales-portal/turnover/turnover.component';
import { TurnoverDetailComponent } from './pages/sales-portal/turnover/detail/turnover-detail.component';
import { TurnoverSettingComponent } from './pages/sales-portal/turnover/setting/turnover-setting.component';
// sales portal - workshop-acquisition
import { WorkshopAcquisitionComponent } from './pages/sales-portal/workshop-acquisition/workshop-acquisition.component';
import { WorkshopAcquisitionDetailComponent } from './pages/sales-portal/workshop-acquisition/detail/workshop-acquisition-detail.component';
import { WorkshopAcquisitionSettingComponent } from './pages/sales-portal/workshop-acquisition/setting/workshop-acquisition-setting.component';
import { RouteReuseStrategy } from '@angular/router';
import { ReuseService } from './services/route-reuse.service';
import { LoginComponent } from './pages/login/login.component';
// dealer-portal
import { ClaimComponent } from './pages/dealer-portal/claim/claim.component';
import { ClaimOverviewComponent } from './pages/claim/claim-overview/claim-overview.component';
import { WarrantyComponent } from './pages/warranty/warranty.component';
import { CreateClaimComponent } from './pages/claim/create-claim/create-claim.component';
import { ClaimQuantityInputComponent } from './pages/claim/claim-quantity-input/claim-quantity-input.component';
import { ClaimDetailComponent } from './pages/claim/claim-detail/claim-detail.component';
import { ClaimDetailPdfComponent } from './pages/claim/claim-detail-pdf/claim-detail-pdf.component';
import { PieChartComponent } from './pages/dealer-portal/components/pie-chart.component';
import { DocumentsComponent } from './pages/documents/documents.component';
import { WiperIntroComponent } from './pages/wiper-intro-page/wiper-intro.component';
import { WorkShopComponent } from './pages/work-shop/work-shop.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
// My Account
import { DataProtectionPolicyComponent } from './pages/user-info/data-protection-policy/index.component';
import { PrivacyStatementComponent } from './pages/user-info/data-protection-policy/privacy-statement/index.component';
import { CooperateInformation } from './pages/user-info/data-protection-policy/cooperate-information/index.component';

/** 导入需要使用的语言包 **/
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import zh from '@angular/common/locales/zh';
registerLocaleData(en);
registerLocaleData(zh);
/** 配置 ng-zorro-antd 国际化 **/
import { en_US, NZ_I18N, zh_CN } from 'ng-zorro-antd/i18n';
import { CustomerComponent } from './pages/cart/customer/customer.component';
import { QuantityInputComponent } from './pages/cart/quantity-input/quantity-input.component';
import { OrderTermsComponent } from './pages/user-info/order-terms/order-terms.component';
import { GettokenComponent } from './pages/login/gettoken/gettoken.component';
import { ProductSearchComponent } from './pages/official-website/ecat/product-search/product-search.component';
import { PartDetailComponent } from './pages/official-website/ecat/part-detail/part-detail.component';
import { PartDetailMobileComponent } from './pages/official-website/ecat/part-detail/part-detail-mobile.component';
import { ContractComponent } from './pages/rebate_contract/contract/contract.component';
import { RebateComponent } from './pages/rebate_contract/rebate/rebate.component';
import { RebateContractComponent } from './pages/rebate_contract/rebate-contract.component';
import { MarketingActivityComponent } from './pages/marketing-activity/marketing-activity.component';
import { MarketingActivityCostComponent } from './pages/marketing-activity/cost/marketing-activity-cost.component';
import { MarketingActivityCardComponent } from './pages/marketing-activity/marketing-activity-card/marketing-activity-card.component';
import { MarketingMaterialCardComponent } from './pages/marketing-activity/marketing-material-card/marketing-material-card.component';
import { MarketingActivityMaterialComponent } from './pages/marketing-activity/material/marketing-activity-material.component';
import { PromotionActivityComponent } from './pages/promotion-activity/promotion-activity.component';
import { DataTableComponent } from './pages/rebate_contract/data-table/data-table.component';
import { CustomMultiSearchComponent } from './components/custom-multi-select/custom-multi-search.component';
import { ChatbotComponent } from './components/chatbot/chatbot.component';

import { EcatMobileHomepageComponent } from './pages/official-website/ecat/mobile/ecat-mobile-homepage.component';
import { MobileProductCartBottomComponent } from './pages/official-website/ecat/mobile/mobile-product-cart-bottom/mobile-product-cart-bottom.component';
import { SearchByCarComponent } from './pages/official-website/ecat/mobile/search-by-car/search-by-car.component';
import { SearchByMaterialComponent } from './pages/official-website/ecat/mobile/search-by-material/search-by-material.component';
import { EcatMobileSearchComponent } from './pages/official-website/ecat/mobile/ecat-mobile-search/ecat-mobile-search.component';
import { EcatMobilePartListComponent } from './pages/official-website/ecat/mobile/ecat-mobile-part-list/ecat-mobile-part-list.component';
// HttpLoaderFactory to load translation files
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', `.json?v=${Date.now().toString()}`);
}
const maskConfig: Partial<IConfig> = {
  validation: false,
};
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    DictionaryComponent,
    LogComponent,
    GenerateComponent,
    GlobalConfigComponent,
    CustomConfigComponent,
    NoAuthComponent,
    AppFooterComponent,
    AppHeaderComponent,
    OfficialWebsiteHeaderComponent,
    IndexComponent,
    HomePageComponent,
    HomePageBackupComponent,
    PercentRingComponent,
    ServicesComponent,
    PartsComponent,
    VinSearchComponent,
    VinPartsSearchComponent,
    ServiceTrainingComponent,
    EquipmentServicesComponent,
    EmptyNewPageComponent,
    NewsCenterComponent,
    NewsDetailComponent,
    DieselRepairNetworkComponent,
    BSSPartsSelectionComponent,
    CVPlanComponent,
    VideoModalComponent,
    VideoPlayerComponent,
    SafeUrlPipe,
    ExtraRewardsComponent,
    ScrollSpyNavComponent,
    ContactUsComponent,
    OfficialWebsiteFooterComponent,
    CartIndexComponent,
    TargetAchievementComponent,
    QuickAddComponent,
    SubTitleComponent,
    BreadcrumbNavigation,
    MultipleLineComponent,
    CopyPasteComponent,
    CsvExcelComponent,
    CartComponent,
    CartListComponent,
    CartTableComponent,
    OrderSuccessComponent,
    DeliveryHistoryComponent,
    FinancialDataComponent,
    OrderHistoryIndex,
    DeliveryHistoryComponent,
    OrderHistoryComponent,
    ItemHistoryComponent,
    CartAddressComponent,
    ProgressComponent,
    LogProcessComponent,
    SvgIconComponent,
    EditAddressComponent,
    UserInfoComponent,
    MyAccountComponent,
    DataPrivacyMessage,
    UserTermsMessage,
    MyAccountSoldToDetail,
    CustomTagComponent,
    ChooseAddressComponent,
    NotificationComponent,
    NotificationDataComponent,
    InvoiceDataComponent,
    NotificationSettingComponent,
    OrganizationProfileComponent,
    OrderDetailComponent,
    LoadingComponent,
    ProductComponent,
    SearchComponent,
    ProductVinSearchComponent,
    ProductCompanySearchComponent,
    NewFeatureGuideComponent,
    PromotionPopupWindowComponent,
    CategoryComponent,
    ProductCategoryMobileComponent,
    ProductDetailComponent,
    ProductDetailMobileComponent,
    ProductListMobileComponent,
    ProductVehicleSearchComponent,
    VehicleModalComponent,
    OrderInProcessComponent,
    OrderFailedComponent,
    WishlistComponent,
    MagnifyDirective,
    DebounceClickDirective,
    DealerPortalHome,
    DealerTargetAchievementComponent,
    DealerPortalRightSectionComponent,
    DealerWorkshopAcquisitionComponent,
    // sales portal
    SalesPortalNavComponent,
    ProductGroupTableComponent,
    TwoColumnTableComponent,
    SpCircleProgressComponent,
    SalesPortalHeaderComponent,
    SalesPortalInputNumberComponent,
    TurnoverComponent,
    TurnoverDetailComponent,
    TurnoverSettingComponent,
    WorkshopAcquisitionComponent,
    WorkshopAcquisitionDetailComponent,
    WorkshopAcquisitionSettingComponent,
    // dealer portal
    ClaimComponent,
    ClaimOverviewComponent,
    WarrantyComponent,
    CreateClaimComponent,
    ClaimQuantityInputComponent,
    ClaimDetailComponent,
    ClaimDetailPdfComponent,
    PieChartComponent,
    LoginComponent,
    DocumentsComponent,
    WiperIntroComponent,
    WorkShopComponent,
    // my account
    DataProtectionPolicyComponent,
    PrivacyStatementComponent,
    CooperateInformation,
    CustomerComponent,
    QuantityInputComponent,
    OrderTermsComponent,
    GettokenComponent,
    ProductSearchComponent,
    PartDetailComponent,
    PartDetailMobileComponent,
    EcatMobileHomepageComponent,
    MobileProductCartBottomComponent,
    SearchByCarComponent,
    SearchByMaterialComponent,
    EcatMobileSearchComponent,
    EcatMobilePartListComponent,
    ContractComponent,
    RebateComponent,
    RebateContractComponent,
    MarketingActivityComponent,
    PromotionActivityComponent,
    MarketingActivityCostComponent,
    MarketingActivityCardComponent,
    MarketingMaterialCardComponent,
    MarketingActivityMaterialComponent,
    CustomMultiSearchComponent,
    DataTableComponent,
    ChatbotComponent
  ],
  imports: [
    ScrollingModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NzInputModule,
    NzBreadCrumbModule,
    NzSelectModule,
    NzMessageModule,
    NzDropDownModule,
    NzPageHeaderModule,
    NzSpinModule,
    NzModalModule,
    NzImageModule,
    NzAvatarModule,
    NzIconModule,
    NzPopconfirmModule,
    NzTableModule,
    NzToolTipModule,
    NzButtonModule,
    NzFormModule,
    NzUploadModule,
    ReactiveFormsModule,
    UserManagementModule,
    RoleManagementModule,
    PermissionManagementModule,
    NzDrawerModule,
    NzGridModule,
    NzRadioModule,
    NzCarouselModule,
    NzPopoverModule,
    NzDatePickerModule,
    NzInputNumberModule,
    NzCheckboxModule,
    NzTabsModule,
    NzTagModule,
    NzProgressModule,
    NzSwitchModule,
    CommonModule,
    NzCardModule,
    NzEmptyModule,
    NzTreeModule,
    NzBackTopModule,
    NzPaginationModule,
    NzMenuModule,
    NzCollapseModule,
    NgxMaskModule.forRoot(maskConfig),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    InputNumberModule,
  ],
  providers: [
    {
      provide: NZ_I18N,
      useFactory: (localId: string) => {
        switch (localId) {
          case 'en':
            return en_US;
          /** 与 angular.json i18n/locales 配置一致 **/
          case 'zh':
            return zh_CN;
          default:
            return en_US;
        }
      },
      deps: [LOCALE_ID],
    },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true },
    { provide: RouteReuseStrategy, useClass: ReuseService },
    {
      provide: APP_BASE_HREF,
      useValue: window.location.pathname.startsWith('/gb/cn') ? '/'
      : window.location.pathname.startsWith('/Salesportal') ? '/Salesportal/' : '/Dealerportal/',
    },
    DatePipe,
    LoadingService,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AppModule {}
